import axios from "axios";
import api from '../../utils/axios';



export const register = async (value) =>
  await axios.post(process.env.REACT_APP_API + "/register", value);

export const login = async (value) =>
  await axios.post(process.env.REACT_APP_API + "/login", value);

  export const currentUser = () => api.post('/current-user');      // header จะติดอัตโนมัติจาก interceptor
  export const currentAdmin = () => api.post('/current-admin');